
import Sidebar from "../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import { useAuthState } from "../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { GardenDashMainCountDataAPI } from "../../../Redux/MainCountSlice/GardenMainCount"
import { Loading } from "../../../Helper/Loading"
import { useSearchParams } from "react-router-dom"
import CommonDashboardWardNameDDL from "./CommonDashboardWardNameDDL"
import { useTranslation } from "react-i18next"
import { EmployeeAndContractorWisePendingWorkCard } from "./GarderDashboardComponent/EmployeeAndContractorWiseWorkPending/EmployeeAndContractorWiseWorkPendingCard"
import { GardenWorkDailyChecklist } from "./NewDashBoardComponents/GardenWorkDailyChecklist/GardenWorkDailyChecklist"
import { WorkTypeButtonGetAPI } from "../../../Redux/MainCountSlice/MainWorkTypeButtonSlice"
import OfficialMasterCardData from "./GarderDashboardComponent/GardenMasterCard/OfficialMasterCardData"
import { EducationRoadWorkDailyChecklist } from "./EducationDashboard/EducationRoadWorkDailyChecklist/EducationRoadWorkDailyChecklist"

export const OfficialDashboard = (props) => {

    const { LanguageID } = props

    const { t } = useTranslation()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Countdata, setCountdata] = useState({})

    const [WorkTypeBtnData, setWorkTypeBtnData] = useState([])
    const [WorkActiveButton, setWorkActiveButton] = useState(0);

    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ZoneValue, setZoneValue] = useState(null)
    const [ZoneLabel, setZoneLabel] = useState(null)
    const [Date, setDate] = useState('');

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: LanguageID != undefined ? LanguageID : localStorage.getItem('LanguageChange')
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: LanguageID != undefined ? LanguageID : localStorage.getItem('LanguageChange'),
        })
    }, [LanguageID])

    const [ZoneNameDDLID, setZoneNameDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "",
    })

    const [ActiveButton, setActiveButton] = useState('उद्यान दैनंदिन कामे');

    const handleButtonClick = (index) => {
        setActiveButton(index);
    };

    const [ActiveMasterCard, setActiveMasterCard] = useState('1')

    const handleActiveMasterCardClick = (navigate) => {
        setActiveMasterCard(navigate);
    };

    const handleGetFinancialYearID = (FinancialYear, Month) => {
        setHeaderMonthID(Month)
        setHeaderFinancialYear(FinancialYear)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: YearValue,
            M_WardID: WardName.ID,
            M_ZoneID: ZoneValue,
            M_MonthID: MonthValue,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount
        }
        dispatch(GardenDashMainCountDataAPI({ data }))

    }, [YearValue, MonthValue, WardName.ID, ZoneValue])

    const { GardenDashCountData, isLoading } = useSelector(state => state.GardenDashMainCountData)

    const handleGetCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    useEffect(() => {

        const data = {
            RoleID: RoleID,
            M_UserID: UserID,
            Flag: "DB_Master",
            token: token,
            Language: Language?.Label,
            handleWorkButtonData: handleWorkButtonData
        }
        console.log('ffgfd', Language)

        { Language?.Label != '' && dispatch(WorkTypeButtonGetAPI({ data })) }

    }, [Language?.Label, ActiveButton, RoleID])

    const { isDDLLoading } = useSelector(state => state.WorkTypeButtonGetData)

    const handleWorkButtonData = (data) => {
        setWorkTypeBtnData && setWorkTypeBtnData(data)
        setWorkActiveButton && setWorkActiveButton(
            (RoleID == 12 || RoleID == 16) ? // Electric
                data && data.length > 0 && data[2]?.workTypeID
                :
                (RoleID == 17 || RoleID == 20) ? // Civil
                    data && data.length > 0 && data[1]?.workTypeID
                    :
                    (RoleID == 30 || RoleID == 31) ? // Security
                        data && data.length > 0 && data[3]?.workTypeID
                        :
                        data && data.length > 0 && data[0]?.workTypeID // Garden
        )
    }

    const handleWorkActiveButtonClick = (WorkTypeID) => {
        setWorkActiveButton(WorkTypeID);
    };



    return (
        <>
            {(isLoading || isDDLLoading) && <Loading />}
            <div>

                <div className="wrapper bg-change">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        Language={Language}
                        YearValue={YearValue}
                        YearLabel={YearLabel}
                        MonthValue={MonthValue}
                        MonthLabel={MonthLabel}
                        WardValue={WardValue}
                        WardLabel={WardLabel}
                        ZoneValue={ZoneValue}
                        ZoneLabel={ZoneLabel}
                    />

                    <div className="content1 content mt-1" style={{ height: '100vh' }}>

                        {/* Year Month Total */}
                        <CommonDashboardWardNameDDL
                            Countdata={Countdata}
                            YearValue={YearValue}
                            setYearValue={setYearValue}
                            YearLabel={YearLabel}
                            setYearLabel={setYearLabel}
                            MonthValue={MonthValue}
                            setMonthValue={setMonthValue}
                            MonthLabel={MonthLabel}
                            setMonthLabel={setMonthLabel}
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                            setZoneValue={setZoneValue}
                            setZoneLabel={setZoneLabel}
                            Language={Language}
                            ZoneNameDDLID={ZoneNameDDLID}
                            setZoneNameDDLID={setZoneNameDDLID}
                            WardName={WardName}
                            setWardName={setWardName}
                            Flag='officer'
                        />

                        <div className="py-2 master_border_master_card  me-lg-2">
                            {/* Garden Road Divider */}
                            <OfficialMasterCardData
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ZoneValue={ZoneValue}
                                ZoneLabel={ZoneLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                                Language={Language}
                                ActiveMasterCard={ActiveMasterCard}
                                setActiveMasterCard={setActiveMasterCard}
                                handleActiveMasterCardClick={handleActiveMasterCardClick}
                                ActiveButton={ActiveButton}
                                setActiveButton={setActiveButton}
                                handleButtonClick={handleButtonClick}
                            />

                        </div>

                        <div className=" m-0 pe-2 mb-5  pb-5">
                            {
                                ((ActiveButton == "उद्यान दैनंदिन कामे") && (ActiveMasterCard == '1')) &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-3">
                                            <p className="pt-1 fw-bold mb-0 text-white" style={{ fontSize: '19px' }}>{t('Dashboard.Titles.Garden_Daily_Work')} </p>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                // disabled={RoleID == 12}
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={(e) => { (RoleID == 12 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31) ? e.preventDefault() : handleWorkActiveButtonClick(i.workTypeID) }}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-1 float-end ">
                                            <label for="exampleInputEmail1"
                                                className="form-label pt-1 float-end fw-bold text-white fs-6"
                                            >{t('EncroachmentDashboard.date')} :</label>
                                        </div>
                                        <div className="col-12 col-lg-2 pb-1">
                                            <input type="date"
                                                class="form-control "
                                                id="exampleInputEmail1"
                                                aria-describedby="emailHelp"
                                                name="Date"
                                                value={Date}
                                                onChange={(e) => setDate(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {
                                        RoleID == 2 || RoleID == 3 || RoleID == 7 || RoleID == 10 || RoleID == 12 || RoleID == 15 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31 ?
                                            <div className="me-0 ms-0 mt-1 me-1 pb-0 pe-1 master_border ">
                                                {/* Garden Table  */}
                                                <GardenWorkDailyChecklist
                                                    YearValue={YearValue}
                                                    MonthValue={MonthValue}
                                                    WardValue={WardValue}
                                                    ZoneValue={ZoneValue}
                                                    Language={Language}
                                                    AssetType='1'
                                                    Date={Date}
                                                    WorkActiveButton={WorkActiveButton}
                                                    ActiveButton='Daily_Officer'
                                                />
                                            </div>
                                            :
                                            <></>
                                    }
                                </>
                            }


                            {/* Road Divider Section */}
                            {
                                ((ActiveButton == "उद्यान दैनंदिन कामे") && (ActiveMasterCard == '2')) &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-9">
                                            <p className="pt-1 fw-bold mb-0 text-white" style={{ fontSize: '19px' }}>{t('Dashboard.Pcmc_Assets.Road_Divider')} </p>
                                        </div>
                                        <div className="col-12 col-lg-1 float-end ">
                                            <label for="exampleInputEmail1"
                                                className="form-label pt-1 float-end fw-bold text-white fs-6"
                                            >{t('EncroachmentDashboard.date')} :</label>
                                        </div>
                                        <div className="col-12 col-lg-2 pb-1">
                                            <input type="date"
                                                class="form-control "
                                                id="exampleInputEmail1"
                                                aria-describedby="emailHelp"
                                                name="Date"
                                                value={Date}
                                                onChange={(e) => setDate(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {
                                        RoleID == 2 || RoleID == 3 || RoleID == 7 || RoleID == 10 || RoleID == 15 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31 ?
                                            <div className="me-0 ms-0 mt-1 me-1 pb-0 pe-1 master_border ">
                                                {/* <EducationRoadWorkDailyChecklist
                                                    YearValue={YearValue}
                                                    MonthValue={MonthValue}
                                                    WardValue={WardValue}
                                                    ZoneValue={ZoneValue}
                                                    Language={Language}
                                                    AssetType='2'
                                                    Date={Date}
                                                    WorkActiveButton={WorkActiveButton}
                                                    ActiveButton='Daily_Officer'
                                                /> */}

                                                <GardenWorkDailyChecklist
                                                    YearValue={YearValue}
                                                    MonthValue={MonthValue}
                                                    WardValue={WardValue}
                                                    ZoneValue={ZoneValue}
                                                    Language={Language}
                                                    AssetType='2'
                                                    Date={Date}
                                                    WorkActiveButton={WorkActiveButton}
                                                    ActiveButton='Daily_Officer'
                                                />

                                            </div>
                                            :
                                            <></>
                                    }
                                </>
                            }

                            {
                                ActiveButton == "प्रशासनाने वाटप केलेली कामे" &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-7 py-1">
                                            <span className="fw-bold" style={{ fontSize: "19px" }}>{t('Dashboard.Titles.Work_Assigned_by_Officials')} -  {t('EmployeeAndContractor.Officer_Name_Pending_Work_Status')}</span>

                                        </div>
                                        <div className="col-12 col-lg-5 pb-1">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={(e) => { (RoleID == 12 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31) ? e.preventDefault() : handleWorkActiveButtonClick(i.workTypeID) }}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="border rounded mt-0  me-0 my-1 rounded bg-white border-0 sec_sec sec_sec_375 px-2 ps-2 pt-0">

                                        {
                                            RoleID == 2 || RoleID == 3 || RoleID == 12 || RoleID == 15 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31 ?

                                                <div className=" mt-2 m-0 p-0 master_border last_row">
                                                    <EmployeeAndContractorWisePendingWorkCard
                                                        ActiveButton='कर्मचारी'
                                                        ZoneValue={ZoneValue}
                                                        WardValue={WardValue}
                                                        Language={Language}
                                                        WorkActiveButton={WorkActiveButton}
                                                    />
                                                </div>
                                                : ''
                                        }

                                    </div>
                                </>
                            }

                            {/* Work Progress Card Start */}

                            {/* Work Progress By Contractor */}

                            {
                                ActiveButton == "ठेकेदारनिहाय कामाची प्रगती" &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-7 py-1">
                                            <span className="fw-bold" style={{ fontSize: "19px" }}>{t('Dashboard.Titles.Work_Progress_By_Contractor')} - {t('EmployeeAndContractor.Contractor_Name_Pending_Work_Status')}</span>
                                        </div>
                                        <div className="col-12 col-lg-5 pb-1">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={(e) => { (RoleID == 12 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31) ? e.preventDefault() : handleWorkActiveButtonClick(i.workTypeID) }}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>


                                    <div className="border m-0 my-1 rounded border-0 p-2 sec_sec bg-white">

                                        {
                                            RoleID == 2 || RoleID == 3 || RoleID == 12 || RoleID == 15 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31 ?

                                                <div className=" m-0 p-0 master_border last_row">
                                                    <EmployeeAndContractorWisePendingWorkCard
                                                        ActiveButton='ठेकेदार'
                                                        ZoneValue={ZoneValue}
                                                        WardValue={WardValue}
                                                        Language={Language}
                                                        WorkActiveButton={WorkActiveButton}
                                                    />
                                                </div>
                                                : ''
                                        }
                                    </div>

                                </>
                            }
                            {/* Work Progress Card End */}


                            {/* Reopen Work Progress Card Start */}
                            {
                                ActiveButton == "पुन्हा वाटप केलेल्या कामाची प्रगती" &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-7 py-1">
                                            <span className="fw-bold" style={{ fontSize: "19px" }}>{t('Dashboard.Titles.Work_Reopen_Progress_By_Contractor')} - {t('EmployeeAndContractor.Contractor_Name_Pending_Work_Status')}</span>

                                        </div>
                                        <div className="col-12 col-lg-5 pb-1">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={(e) => { (RoleID == 12 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31) ? e.preventDefault() : handleWorkActiveButtonClick(i.workTypeID) }}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>


                                    <div className="border m-0 rounded bg-white border-0 p-2 pb-2 sec_sec">

                                        {
                                            RoleID == 2 || RoleID == 3 || RoleID == 12 || RoleID == 15 || RoleID == 17 || RoleID == 20 || RoleID == 16 || RoleID == 30 || RoleID == 31 ?

                                                <div className="m-0 p-0 master_border last_row">
                                                    <EmployeeAndContractorWisePendingWorkCard
                                                        ActiveButton='ReopenContractor'
                                                        ZoneValue={ZoneValue}
                                                        WardValue={WardValue}
                                                        Language={Language}
                                                        WorkActiveButton={WorkActiveButton}
                                                    />
                                                </div>
                                                : ''
                                        }
                                    </div>

                                </>
                            }

                        </div>

                        {/* REopen Work Progress Card End */}

                    </div>

                </div>



            </div>


        </>

    )
}